import { z, ZodError, ZodObject } from 'zod'
import { FetchError } from 'ofetch'

export const useErrors = (
  schema: ZodObject<any>,
  mutateError: { value: ZodError | FetchError | any },
) => {
  return computed<z.inferFormattedError<typeof schema>>(() => {
    if (mutateError.value instanceof ZodError) return mutateError.value.format()
    if (mutateError.value instanceof FetchError) return mutateError.value.data

    return mutateError.value
  })
}

export const useApiError = () => {
  const { t } = useI18n()

  const errorCodeMessageMaps = computed(() => {
    return {
      '401': t('error.message.unauthorized'),
      '403': t('error.message.forbidden'),
      '404': t('error.message.notFound'),
      '400': t('error.message.badRequest'),
    }
  })

  const getApiErrorMessage = (
    error: { _data?: { error?: string }; status?: number; statusCode?: number },
    fallbackMessage = '',
  ) => {
    const code = error?.status ?? error?.statusCode
    if (code || error._data?.error) {
      return errorCodeMessageMaps.value[`${code}`] ?? error._data?.error
      //translatred error messages takes higher precedence for now
    }
    return fallbackMessage
  }

  return {
    errorCodeMessageMaps,
    getApiErrorMessage,
  }
}
